module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/NI-467845a5b2c9b6d70e4b486bb8b51b4f.png";